import gql from 'graphql-tag'
import { properties } from '../fragments'

// Returns Product type
export const updateProductProperties = gql`
mutation updateProductProperties($productId: ID! $fields: ProductPropertiesInput!) {
	cashAssist {
		updateProductProperties(productId: $productId, fields: $fields) {
			id
			mod_ver
			...properties
		}
	}
}
${properties}
`

export default updateProductProperties
